"use strict";

(function(){

var self = Fotobook.holidays.renderer = {


    /** темплейт стиля */
    _markStyleTemplate: [
        '<style class="mark-style">',
            "#{uniqueId} + *{\n",
                "color:{color}\n",
            "}\n",
        '</style>',
    ].join(""),

    /** отрисовка стиля значка */
    drawMarkStyle: function(uniqueId, date_style){
        return self._markStyleTemplate.supplant($.extend({
            "uniqueId": uniqueId,
            "color": date_style.color || "inherit",
        }));
    },

    /** темплейт значка */
    _markFigureTemplate: [
        '<svg width="100%" height="100%" class="date-mark-wrapper figure">',
            '<use href="#holiday-mark-{mark-id}" class="date-mark" fill="{fill-color}" fill-opacity="{fill-opacity}" stroke="{fill-color}" stroke-opacity="{fill-opacity}" />',
        '</svg>',
    ].join(""),

    /** отрисовка иконки */
    drawMarkFigure: function(dateStyle){
        if (!dateStyle || !dateStyle.mark_id) {
            return "";
        }
        var color = new WebColor(dateStyle.mark_color);
        return self._markFigureTemplate.supplant({
            "mark-id": dateStyle.mark_id,
            "fill-color": color.get_hex(),
            "fill-opacity": color.a,
        });
    },

    _markFotoTemplate:
        `<div class="date-mark-wrapper foto" style="opacity:{opacity};">
            <img
                src="{url}"
                class="date-mark-foto"
                style="--foto-angle: {fotoAngle}deg; --foto-angle-sin: {sin}; --foto-angle-cos: {cos};"
            >
        </div>`
    ,
    drawMarkFoto(dateStyle) {
        if (!dateStyle || !dateStyle.foto) {
            return '';
        }
        const angle = Fotobook.angles.normalizeAngle(dateStyle.foto.angle ?? 0);
        const angleRad = Fotobook.angles.deg2rad(angle);
        const cos = Math.abs(Math.cos(angleRad));
        const sin = Math.abs(Math.sin(angleRad));
        const scale = cos + sin;
        return this._markFotoTemplate.supplant({
            url: Fotobook.createStorageUrl(dateStyle.foto.preview_path),
            opacity: dateStyle.foto_opacity / 100,
            fotoAngle: angle,
            scale,
            sin,
            cos,
        });
    },

    drawMarkBackground: function(dateStyle){
        return this.drawMarkFoto(dateStyle) || this.drawMarkFigure(dateStyle);
    },

    /** темплейт значка и стиля */
    _markTemplate: [
        '<div id="{uniqueId}" class="holiday-mark append-mark-style">',
            '{background}',
            '{style}',
        '</div>',
    ].join(""),

    /** отрисовка значка по структуре пользовательской даты */
    drawMarkLayout: function(holiday){
        var uniqueId = Fotobook.book.getUniqueId(),
            params = {
                "uniqueId": uniqueId,
                "background": self.drawMarkBackground(holiday.date_style),
                "style": self.drawMarkStyle(uniqueId, holiday.date_style),
            };

        return self._markTemplate.supplant(params);
    },

    /** отрисовка значка по дате */
    drawMark: function (date) {
        var holiday = self.getDate(date);
        if (!holiday) {
            return "";
        }

        return self.drawMarkLayout(holiday);
    },

};

})();
